<!-- Dealer Detail Popup -->
<div class="popup-overlay" [class.show]="visible" (click)="close()">
  <div class="popup-content" (click)="$event.stopPropagation()" *ngIf="dealer">
    <div class="popup-header">
      <h4 class="popup-title">
        <i class="fas fa-store me-2"></i>
        Dettagli Dealer: {{ dealer.dealerName || dealer.dealerLegalName }}
      </h4>
      <button type="button" class="btn-close" (click)="close()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Tabs Navigation -->
    <div class="popup-tabs">
      <button type="button"
              class="tab-btn"
              [class.active]="activeTab === 'details'"
              (click)="setActiveTab('details')">
        <i class="fas fa-info-circle me-2"></i>
        Dati Anagrafici
      </button>
      <button type="button"
              class="tab-btn"
              [class.active]="activeTab === 'map'"
              (click)="setActiveTab('map')">
        <i class="fas fa-map-marker-alt me-2"></i>
        Mappa
      </button>
    </div>

    <div class="popup-body">
      <!-- Tab: Dati Anagrafici -->
      <div class="tab-content" *ngIf="activeTab === 'details'">
        <div class="dealer-details">

          <!-- Header riepilogo -->
          <div class="details-summary">
            <div class="details-summary-item">
              <i class="fas fa-store"></i>
              <span>Dealer: <strong>{{ dealer.dealerName || dealer.dealerLegalName || dealer.dealerCode }}</strong></span>
            </div>
            <div class="details-summary-item" *ngIf="dealer.dealerOperatingAddressCity">
              <i class="fas fa-city"></i>
              <span>{{ dealer.dealerOperatingAddressCity }}<ng-container *ngIf="dealer.dealerOperatingAddressProvince"> ({{ dealer.dealerOperatingAddressProvince }})</ng-container></span>
            </div>
            <div class="details-summary-item" *ngIf="dealer.dealerStatus">
              <span class="details-status-badge" [ngClass]="getStatusBadgeClass()">
                <i class="fas fa-circle status-dot"></i>
                {{ dealer.dealerStatus }}
              </span>
            </div>
          </div>

          <!-- Sezione Identificazione -->
          <div class="details-card">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-id-card"></i>
              </div>
              <h5 class="details-card-title">Identificazione</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Codice Dealer</span>
                  <div class="details-value details-value--code">
                    <span>{{ dealer.dealerCode || '-' }}</span>
                    <i *ngIf="dealer.dealerCode"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(dealer.dealerCode)"
                       title="Copia codice dealer"></i>
                    <i *ngIf="dealer.dealerCode"
                       class="fas fa-external-link-alt copy-icon"
                       (click)="openDealerAnagraphic()"
                       title="Apri scheda anagrafica del dealer"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Nome Commerciale</span>
                  <div class="details-value">
                    <span>{{ dealer.dealerName || '-' }}</span>
                    <i *ngIf="dealer.dealerName"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(dealer.dealerName)"
                       title="Copia nome commerciale"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Ragione Sociale</span>
                  <div class="details-value">
                    <span>{{ dealer.dealerLegalName || '-' }}</span>
                    <i *ngIf="dealer.dealerLegalName"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(dealer.dealerLegalName)"
                       title="Copia ragione sociale"></i>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Codice Legale</span>
                  <div class="details-value details-value--code">
                    <span>{{ dealer.dealerLegalCode || '-' }}</span>
                    <i *ngIf="dealer.dealerLegalCode"
                       class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(dealer.dealerLegalCode)"
                       title="Copia codice legale"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Dati Fiscali -->
          <div class="details-card" *ngIf="dealer.dealerVatNumber || dealer.dealerSdiCode">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-file-invoice-dollar"></i>
              </div>
              <h5 class="details-card-title">Dati Fiscali</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item" *ngIf="dealer.dealerVatNumber">
                  <span class="details-label">Partita IVA</span>
                  <div class="details-value details-value--code">
                    <span>{{ dealer.dealerVatNumber }}</span>
                    <i class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(dealer.dealerVatNumber)"
                       title="Copia partita IVA"></i>
                  </div>
                </div>
                <div class="details-item" *ngIf="dealer.dealerSdiCode">
                  <span class="details-label">Codice SDI</span>
                  <div class="details-value details-value--code">
                    <span>{{ dealer.dealerSdiCode }}</span>
                    <i class="fas fa-copy copy-icon"
                       (click)="copyToClipboard(dealer.dealerSdiCode)"
                       title="Copia codice SDI"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Indirizzo Legale -->
          <div class="details-card" *ngIf="dealer.dealerLegalAddressStreet || dealer.dealerLegalAddressCity">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-building"></i>
              </div>
              <h5 class="details-card-title">Indirizzo Legale</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item details-item--wide">
                  <span class="details-label">Indirizzo</span>
                  <div class="details-value details-value--stacked">
                    <div *ngIf="dealer.dealerLegalAddressStreet">
                      <i class="fas fa-road me-1 text-muted"></i>
                      {{ dealer.dealerLegalAddressStreet }} {{ dealer.dealerLegalAddressNumber }}
                    </div>
                    <div *ngIf="dealer.dealerLegalAddressZip || dealer.dealerLegalAddressCity">
                      <i class="fas fa-city me-1 text-muted"></i>
                      {{ dealer.dealerLegalAddressZip }} {{ dealer.dealerLegalAddressCity }}
                      <ng-container *ngIf="dealer.dealerLegalAddressProvince">
                        ({{ dealer.dealerLegalAddressProvince }})
                      </ng-container>
                    </div>
                    <div *ngIf="dealer.dealerLegalAddressCountry">
                      <i class="fas fa-globe-europe me-1 text-muted"></i>
                      {{ dealer.dealerLegalAddressCountry }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Indirizzo Operativo -->
          <div class="details-card" *ngIf="dealer.dealerOperatingAddressStreet || dealer.dealerOperatingAddressCity">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-warehouse"></i>
              </div>
              <h5 class="details-card-title">Indirizzo Operativo</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item details-item--wide">
                  <span class="details-label">Indirizzo</span>
                  <div class="details-value details-value--stacked">
                    <div *ngIf="dealer.dealerOperatingAddressStreet">
                      <i class="fas fa-road me-1 text-muted"></i>
                      {{ dealer.dealerOperatingAddressStreet }} {{ dealer.dealerOperatingAddressNumber }}
                    </div>
                    <div *ngIf="dealer.dealerOperatingAddressZip || dealer.dealerOperatingAddressCity">
                      <i class="fas fa-city me-1 text-muted"></i>
                      {{ dealer.dealerOperatingAddressZip }} {{ dealer.dealerOperatingAddressCity }}
                      <ng-container *ngIf="dealer.dealerOperatingAddressProvince">
                        ({{ dealer.dealerOperatingAddressProvince }})
                      </ng-container>
                    </div>
                    <div *ngIf="dealer.dealerOperatingAddressCountry">
                      <i class="fas fa-globe-europe me-1 text-muted"></i>
                      {{ dealer.dealerOperatingAddressCountry }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Informazioni Aggiuntive -->
          <div class="details-card" *ngIf="dealer.dealerStatus || dealer.dealerIndustry || dealer.dealerIncorporationDate">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-info-circle"></i>
              </div>
              <h5 class="details-card-title">Informazioni Aggiuntive</h5>
            </div>
            <div class="details-card-body">
              <div class="details-grid">
                <div class="details-item">
                  <span class="details-label">Stato</span>
                  <div class="details-value">
                    <span class="details-status-badge"
                          *ngIf="dealer.dealerStatus; else noStatus"
                          [ngClass]="getStatusBadgeClass()">
                      <i class="fas fa-circle status-dot"></i>
                      {{ dealer.dealerStatus }}
                    </span>
                    <ng-template #noStatus><span class="text-muted">-</span></ng-template>
                  </div>
                </div>
                <div class="details-item">
                  <span class="details-label">Settore</span>
                  <div class="details-value">{{ dealer.dealerIndustry || '-' }}</div>
                </div>
                <div class="details-item">
                  <span class="details-label">Data Costituzione</span>
                  <div class="details-value">
                    <i class="fas fa-calendar-day me-1 text-muted" *ngIf="dealer.dealerIncorporationDate"></i>
                    {{ dealer.dealerIncorporationDate ? (dealer.dealerIncorporationDate | date:'dd/MM/yyyy') : '-' }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sezione Note -->
          <div class="details-card" *ngIf="dealer.dealerNotes">
            <div class="details-card-header">
              <div class="details-card-icon">
                <i class="fas fa-sticky-note"></i>
              </div>
              <h5 class="details-card-title">Note</h5>
            </div>
            <div class="details-card-body">
              <div class="details-notes">
                {{ dealer.dealerNotes }}
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Tab: Mappa -->
      <div class="tab-content" *ngIf="activeTab === 'map'">
        <div class="dealer-details">

          <!-- Stato: coordinate mancanti -->
          <ng-container *ngIf="!hasValidCoordinates()">
            <div class="details-card">
              <div class="details-card-header">
                <div class="details-card-icon details-card-icon--muted">
                  <i class="fas fa-map-marked-alt"></i>
                </div>
                <h5 class="details-card-title">Posizione Geografica</h5>
              </div>
              <div class="details-card-body">
                <div class="routing-state-box">
                  <i class="fas fa-map-marker-slash fa-3x text-muted mb-3"></i>
                  <p class="mb-1 fw-semibold">Coordinate mancanti</p>
                  <p class="text-muted mb-0 small">
                    Non sono disponibili coordinate GPS per questo dealer.
                  </p>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Mappa + coordinate quando presenti -->
          <ng-container *ngIf="hasValidCoordinates()">
            <div class="details-card">
              <div class="details-card-header">
                <div class="details-card-icon">
                  <i class="fas fa-map-marked-alt"></i>
                </div>
                <h5 class="details-card-title">Posizione Geografica</h5>
              </div>
              <div class="details-card-body p-0">
                <div class="map-container" #mapContainer></div>
              </div>
            </div>

            <div class="details-card">
              <div class="details-card-header">
                <div class="details-card-icon">
                  <i class="fas fa-location-arrow"></i>
                </div>
                <h5 class="details-card-title">Coordinate GPS</h5>
              </div>
              <div class="details-card-body">
                <div class="details-grid">
                  <div class="details-item">
                    <span class="details-label">Latitudine</span>
                    <div class="details-value details-value--code">
                      <span>{{ dealer.dealerLatitude }}</span>
                      <i class="fas fa-copy copy-icon"
                         (click)="copyToClipboard(dealer.dealerLatitude?.toString() || '')"
                         title="Copia latitudine"></i>
                    </div>
                  </div>
                  <div class="details-item">
                    <span class="details-label">Longitudine</span>
                    <div class="details-value details-value--code">
                      <span>{{ dealer.dealerLongitude }}</span>
                      <i class="fas fa-copy copy-icon"
                         (click)="copyToClipboard(dealer.dealerLongitude?.toString() || '')"
                         title="Copia longitudine"></i>
                    </div>
                  </div>
                  <div class="details-item" *ngIf="dealer.dealerCoordinatesOrigin">
                    <span class="details-label">Origine Coordinate</span>
                    <div class="details-value">{{ dealer.dealerCoordinatesOrigin }}</div>
                  </div>
                  <div class="details-item">
                    <span class="details-label">Mappa Esterna</span>
                    <div class="details-value">
                      <a [href]="getCoordinatesMapUrl()"
                         target="_blank"
                         class="btn btn-sm btn-outline-primary">
                        <i class="fas fa-external-link-alt me-1"></i>
                        Apri in Google Maps
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

        </div>
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-secondary" (click)="close()">
          <i class="fas fa-times me-2"></i>
          Chiudi
        </button>
      </div>
    </div>
  </div>
</div>
